import { PageDto } from '@asset-metrix/portal-gateway-client-js';

import { FilterConfigDto } from '../store/states/filterTypes';

import { GLOBAL_FILTER_URL_PARAM_PREFIX } from './constants';

export function createGlobalFilterSearchParamKey(filterId: string) {
  return `${GLOBAL_FILTER_URL_PARAM_PREFIX}${filterId}`;
}

export function getGlobalSearchFiltersFromPage(
  page: PageDto
): { widgetId: string; metadataId: string }[] {
  return recursivelyGetGlobalSearchFilters(page.contents);
}

function recursivelyGetGlobalSearchFilters(
  contents: PageDto['contents']
): { widgetId: string; metadataId: string }[] {
  const result: { widgetId: string; metadataId: string }[] = [];
  return contents.reduce((acc, content) => {
    if (
      content.type === 'singleColumnGroup' ||
      content.type === 'twoColumnGroup'
    ) {
      return [...acc, ...recursivelyGetGlobalSearchFilters(content.contents)];
    }

    if (content.type === 'tabGroup') {
      return [
        ...acc,
        ...recursivelyGetGlobalSearchFilters(
          content.contents.flatMap((tab) => tab.contents)
        ),
      ];
    }

    if (content.type === 'widget' && content.entity.type === 'table') {
      const metadataIds: { widgetId: string; metadataId: string }[] =
        content.entity.config.filters
          ?.filter((f) => f.type === 'text' && f.isGlobalSearchFilter)
          .map((f: FilterConfigDto) => ({
            widgetId: content.id,
            metadataId: f.key,
          })) ?? [];
      return [...acc, ...metadataIds];
    }
    return acc;
  }, result);
}
